import { render } from "./upgrade.vue?vue&type=template&id=69c9cd8c"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"

import "./upgrade.vue?vue&type=style&index=0&id=69c9cd8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__